<h3 i18n>Welcome to Copilot</h3>

<p i18n>
  You appear to have no organizations assigned to your account.
  Please contact your administrator to get access.
</p>

<button mat-flat-button color="primary" (click)="logout()" i18n>
  Sign Out
</button>